import { useState } from 'react';
import { Button, IconButton } from '@hyperflake/react-ui-library';
import { Popover } from '@library/popover';
import { CrossIcon } from '@icon/index';

interface ConfirmDeletePresetButtonProps {
    onConfirm: () => void;
    isLoading?: boolean;
    presetName?: string;
}

const ConfirmDeletePreset = ({ onConfirm, isLoading, presetName }: ConfirmDeletePresetButtonProps) => {
    const [open, setOpen] = useState(false);

    const handleConfirm = () => {
        onConfirm();
        setOpen(false);
    };

    return (
        <Popover
            placement="top-start"
            open={open}
            setOpen={setOpen}
            contentClassName="px-4 py-3 rounded-xl shadow-lg bg-white w-64"
            content={
                <div>
                    <p className="text-sm text-grayscale-800 mb-1">
                        Delete preset{presetName ? ` "${presetName}"` : ''}?
                    </p>
                    <p className="text-xs text-grayscale-400 mb-3">This action cannot be undone.</p>
                    <div className="flex justify-end gap-2">
                        <Button size="xs" variant="shaded" onClick={() => setOpen(false)} disabled={isLoading}>
                            Cancel
                        </Button>
                        <Button size="xs" color="danger" onClick={handleConfirm} disabled={isLoading}>
                            {isLoading ? 'Deleting…' : 'Delete'}
                        </Button>
                    </div>
                </div>
            }
        >
            <IconButton size="xs" variant="shaded" color="danger" disabled={isLoading}>
                {isLoading ? (
                    <div className="w-3 h-3 border-2 border-current border-t-transparent animate-spin rounded-full" />
                ) : (
                    <CrossIcon className="w-3 h-3" />
                )}
            </IconButton>
        </Popover>
    );
};

export default ConfirmDeletePreset;
